module.exports = __webpack_public_path__ + "img/web-p2-f3.c1ccb21c.svg";